export default __webpack_public_path__ + "static/char-s-55-en-83681991f2f4e70854c195d93d173f95.png";